import { useState } from "react";
import { Info, X } from "lucide-react";
import { FORMULA_BY_ID } from "@/lib/formulas";

/* Small (i) chip next to a control. Clicking opens an inline popover with the formula. */
export default function FormulaInfo({ formulaId, currentOverride }) {
    const [open, setOpen] = useState(false);
    const f = FORMULA_BY_ID[formulaId];
    if (!f) return null;

    return (
        <span className="relative inline-flex align-middle ml-1">
            <button
                type="button"
                onClick={(e) => { e.preventDefault(); setOpen((v) => !v); }}
                className="w-4 h-4 rounded-full bg-slate-200 hover:bg-[hsl(var(--copper-soft))] text-slate-500 hover:text-[hsl(var(--copper))] flex items-center justify-center transition-colors"
                aria-label={`Formula for ${f.field}`}
                data-testid={`formula-info-${formulaId}`}
                title="View formula"
            >
                <Info className="w-2.5 h-2.5" />
            </button>
            {open && (
                <div className="absolute z-50 left-5 top-0 w-80 rounded-md border border-slate-200 bg-white shadow-lg p-3 text-[11.5px]">
                    <div className="flex items-start justify-between gap-2 mb-2">
                        <div>
                            <div className="eyebrow text-slate-500">{f.section}</div>
                            <div className="text-[12.5px] font-semibold text-slate-900">{f.field}</div>
                        </div>
                        <button type="button" onClick={() => setOpen(false)}
                            className="text-slate-400 hover:text-slate-700">
                            <X className="w-3.5 h-3.5" />
                        </button>
                    </div>
                    <pre className="whitespace-pre-wrap font-mono text-[11px] text-slate-700 bg-slate-50 border border-slate-100 rounded p-2 leading-relaxed">{f.expression}</pre>
                    {f.value_label != null && (
                        <div className="mt-2 flex items-center gap-2 text-slate-600">
                            <span className="font-mono text-[11px]">{f.value_label}</span>
                            <span className="font-mono font-semibold text-[hsl(var(--copper))]">
                                {currentOverride != null ? currentOverride : f.current_value}
                            </span>
                            {currentOverride != null && (
                                <span className="text-[10px] text-amber-700">(overridden)</span>
                            )}
                        </div>
                    )}
                    {f.notes && <div className="mt-2 text-slate-500 text-[11px]">{f.notes}</div>}
                    {f.impact_areas?.length > 0 && (
                        <div className="mt-2">
                            <div className="eyebrow text-slate-500 mb-1">IMPACTS</div>
                            <ul className="list-disc pl-4 space-y-0.5 text-slate-600">
                                {f.impact_areas.map((i) => <li key={i}>{i}</li>)}
                            </ul>
                        </div>
                    )}
                </div>
            )}
        </span>
    );
}
